import { CifraVidrio, Revelar, useCifras } from "./cine";

const S = {
  inmuebles: ["Inmuebles", "Informes de dominio, satélite y PDF de cada garantía", [["analisis_satelitales", "análisis satelitales (país)"], ["parcelas", "parcelas en el índice nacional"]]],
  clientes: ["Mis clientes", "El patrimonio inmobiliario de cada cliente, en un solo lugar", [["titulares", "vínculos en el índice nacional"]]],
  titulares: ["Buscar titular", "Propietarios por nombre, CI o RUC en todo Paraguay", [["titulares", "vínculos titular↔parcela"], ["parcelas", "parcelas en el índice"]]],
  vigilancia: ["Mi cartera", "Seguimiento, alertas y clima de tus garantías", [["analisis_satelitales", "análisis satelitales"]]],
  escribano: ["Informe del registro", "Situación registral del inmueble (RUM): la pide un abogado, un escribano o el propio interesado", [["parcelas", "parcelas"]]],
  barrido: ["Barrido", "Recorrido catastral continuo del país", [["padrones_consultados", "padrones consultados"], ["zonas_completas", "zonas completas"], ["zonas", "zonas"]]],
  novedades: ["Cambios", "Cambios de titular, hipotecas y embargos detectados en todo el índice (se borran a los 6 días)", [["titulares", "vínculos vigilados por el barrido"]]],
  estadisticas: ["Estadísticas", "Top 10 por área de producción y hectáreas/toneladas estimadas por cultivo, país o distrito", [["analisis_satelitales", "análisis satelitales"]]],
  salud: ["Salud", "Estado de los servicios y de las fuentes", [["zonas", "zonas en barrido"]]],
  admin: ["Admin", "Usuarios, empresas y tablas de referencia", [["titulares", "vínculos en el índice"]]],
};

export function SeccionHero({ tab }) {
  const c = useCifras();
  const s = S[tab];
  if (!s) return null;
  return <section key={tab} className="cn-sec" data-testid={`seccion-hero-${tab}`}>
    <img src={`/secciones/${tab}.webp?v=3`} alt="" className="cn-sec-img" />
    <div className="cn-sec-scrim" />
    <div className="relative z-10 flex flex-col lg:flex-row lg:items-end justify-between gap-4 h-full">
      <div>
        <Revelar as="p" className="cn-ojo">TierraScore</Revelar>
        <Revelar as="h1" d={0.06} className="cn-sec-h1" data-testid="seccion-hero-titulo">{s[0]}</Revelar>
        <Revelar as="p" d={0.12} className="text-sm text-white/80 max-w-md">{s[1]}</Revelar>
      </div>
      <div className="flex gap-2">{s[2].map(([k, e], i) => <CifraVidrio key={k} valor={c?.[k]} etq={e} testid={`seccion-cifra-${k}`} d={0.1 + i * 0.06} />)}</div>
    </div>
  </section>;
}
